import React from 'react'
import { Provider } from 'react-redux'
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Main from './components/Main'
import Login from './components/Login'
import Patient from './components/Patient'
import Admin from './components/Admin'
import Footer from './components/Footer'

import user from './reducers/user'
import reply from './reducers/reply'



const reducer = combineReducers({
  user: user.reducer,
  reply: reply.reducer
})

const store = configureStore({ reducer })

const App = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Routes>
          <Route exact path="/" element={<Main/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/patient-summary" element={<Patient/>} />
          <Route path="/summary" element={<Admin/>} />
        </Routes>
        <Footer />
      </Provider>
    </BrowserRouter>
  )
}

export default App
